import * as React from "react"
import StepStrip from "./StepStrip"
import SettingsPanel from "./SettingsPanel"
import { KeyboardIcon, PlayIcon } from "./icons"
import { WidgetTour, WidgetTourStep, WidgetTourStepType } from "../../types"

interface IProps {
  tour: WidgetTour
  activeTab: "steps" | "settings"
  onTabChange: (tab: "steps" | "settings") => void
  onAddStepClick: (type: WidgetTourStepType) => void
  onStepClick: (step: WidgetTourStep) => void
  onRemoveStepClick: (step: WidgetTourStep) => void
  onReorder: (orderedIds: string[]) => void
  onTourChange: (update: Partial<WidgetTour>) => void
  onPreviewClick: () => void
  onCancelClick: () => void
  onSaveAndCloseClick: () => void
}

const BottomBar = (props: IProps) => {
  const steps = [...(props.tour.steps || [])].sort((a, b) => (a.position || 0) - (b.position || 0))

  return (
    <div className="bizzey-tb-bar">
      <div className="bizzey-tb-bar__header">
        <div className="bizzey-tb-bar__tabs">
          <button
            type="button"
            className={`bizzey-tb-tab${props.activeTab === "steps" ? " bizzey-tb-tab--active" : ""}`}
            onClick={() => props.onTabChange("steps")}
          >
            Steps
          </button>
          <button
            type="button"
            className={`bizzey-tb-tab${props.activeTab === "settings" ? " bizzey-tb-tab--active" : ""}`}
            onClick={() => props.onTabChange("settings")}
          >
            Settings
          </button>
        </div>
      </div>

      <div className="bizzey-tb-bar__body">
        {props.activeTab === "steps" ? (
          <StepStrip
            steps={steps}
            onAddClick={props.onAddStepClick}
            onStepClick={props.onStepClick}
            onRemoveClick={props.onRemoveStepClick}
            onReorder={props.onReorder}
          />
        ) : (
          <SettingsPanel tour={props.tour} onChange={props.onTourChange} />
        )}
      </div>

      <div className="bizzey-tb-bar__footer">
        <button type="button" className="bizzey-tb-icon-button" title="Keyboard shortcuts" aria-label="Keyboard shortcuts">
          <KeyboardIcon />
        </button>

        <div className="bizzey-tb-bar__actions">
          <button
            type="button"
            className="bizzey-tb-footer-button bizzey-tb-footer-button--link"
            onClick={props.onPreviewClick}
          >
            <PlayIcon />
            Preview
          </button>
          <button
            type="button"
            className="bizzey-tb-footer-button bizzey-tb-footer-button--ghost"
            onClick={props.onCancelClick}
          >
            Cancel
          </button>
          <button
            type="button"
            className="bizzey-tb-footer-button bizzey-tb-footer-button--primary"
            onClick={props.onSaveAndCloseClick}
          >
            Save and close
          </button>
        </div>
      </div>
    </div>
  )
}

export default BottomBar
